module.exports = __webpack_public_path__ + "static/assets/img/invitation.c049ed97.png";